import { render, staticRenderFns } from "./change-order.vue?vue&type=template&id=f13a8b80&scoped=true"
import script from "./change-order.vue?vue&type=script&lang=js"
export * from "./change-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a8b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13a8b80')) {
      api.createRecord('f13a8b80', component.options)
    } else {
      api.reload('f13a8b80', component.options)
    }
    module.hot.accept("./change-order.vue?vue&type=template&id=f13a8b80&scoped=true", function () {
      api.rerender('f13a8b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/express/components/change-order.vue"
export default component.exports